<template>
    <div class="dialogWrapper" v-show="visible">
        <div class="dialog">
            <header>
                {{title}}
                <span class="close" @click="close">close</span>
            </header>
            <main>
                <!--在父组件中想要改动子组件的内容，就用 slot-->
                <slot></slot>
            </main>
        </div>
    </div>
</template>

<script>
export default {
    name: "MyDialog",
    props: ["title", "visible"],
    methods: {
        close() {
            // 想在父组件监听子组件的事件， 必须要有 $emit
            this.$emit('close')
        }
    }
}
</script>

<style scoped lang="scss">
.dialogWrapper{
  position: fixed;
  background: hsla(0, 0%,0%,0.25);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog {
    background: white;
    min-height: 4em;
    min-width: 10em;
    >header {
        padding: 16px;
        display: flex;
        justify-content: space-between;
    }
    >main {
        padding: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// MyDialog.vue?7f68cf72